module.exports = __webpack_public_path__ + "static/media/tsaiga-qhQEyyHWrAQ-unsplash.3186316c.webp";